import { Directive, Input, ElementRef, OnChanges } from '@angular/core';

@Directive({
    selector: '[appFormatCurrency]'
})
export class FormatCurrencyDirective implements OnChanges {
    @Input('appFormatCurrency') public value: number | null | undefined;

    public constructor(private el: ElementRef) {}

    public ngOnChanges() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        this.el.nativeElement.textContent = this.formatCurrency(this.value);
    }

    private formatCurrency(value: number | null | undefined): string {
        if (value == null) {
            return '';
        }
        const formattedNumber = new Intl.NumberFormat('sv-SE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
        return `${formattedNumber} SEK`;
    }
}
